import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  LETTER_CREATE,
  LETTER_DELETE,
  LETTER_INCOMING_LIST,
  LETTER_OUTGOING_LIST,
  LETTER_PUBLIC_INFO,
  LETTER_STATUS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const letterCreate = createAsyncThunk(
  LETTER_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.LETTER}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.letterCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterDelete = createAsyncThunk(
  LETTER_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.LETTER}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.letterDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterIncomingList = createAsyncThunk(
  LETTER_INCOMING_LIST,
  async (params: PayloadCreatorParams<`${typeof API.LETTER_INCOMING}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.letterIncomingList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterOutgoingList = createAsyncThunk(
  LETTER_OUTGOING_LIST,
  async (params: PayloadCreatorParams<`${typeof API.LETTER_OUTGOING}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.letterOutgoingList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterStatus = createAsyncThunk(
  LETTER_STATUS,
  async (params: PayloadCreatorParams<`${typeof API.LETTER_STATUS}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.letterStatus(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterPublicInfo = createAsyncThunk(
  LETTER_PUBLIC_INFO,
  async (params: PayloadCreatorParams<`${typeof API.LETTER_PUBLIC_INFO}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.letterPublicInfo(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterIncomingListClear = createAction(`${LETTER_INCOMING_LIST}/clear`)

export const letterOutgoingListClear = createAction(`${LETTER_OUTGOING_LIST}/clear`)
